/**
 * 监控平台
 */
export default {
  MONITORINGPLATFORM: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/monitorPlatform.vue'
    ),
    // labelName: $it('menu.ae')
    labelName: '监控平台',
  },
  OVERVIEW: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/monitorPlatformOne.vue'
    ),
    // labelName: $it('menu.ae')
    labelName: '概览',
  },
  PATROL_INSPECTION: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/360Scan.vue'
    ),
    labelName: '巡检',
  },
  MONITORPLATFORM: {
    component: () => import(
      /* webpackChunkName: 'MonitorCenterPage' */
      'allpages/monitorPlatform/index.vue'
    ),
    labelName: '监控平台',
  }
};
